import React from 'react';
import PropTypes from 'prop-types';
import { theme } from '~/styles/theme';

export default function YellowCardIcon({ size, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 79 100" {...rest}>
      <path
        fill={theme.yellow}
        d="M77.8923767,70 L79,71.0725458 C78.5560538,74.4868166 77.7623318,77.8876806 76.573991,81.1902279 C74.4529148,87.1383882 71.1210762,92.7826605 66.7757848,97.7029644 L64.7533632,100 L60,95.388053 L62.3856502,93.4440638 C66.9237668,89.7527186 70.8161435,85.185461 73.7309417,79.9791449 C75.4887892,76.8553553 76.8878924,73.4947118 77.8923767,70 Z M61.7522,19.39516 L61.7522,82.88516 L15.0706,82.88516 L15.0706,19.39516 L61.7522,19.39516 Z M56.752,24.395 L20.07,24.395 L20.07,77.885 L56.752,77.885 L56.752,24.395 Z M13.5954885,0.426001338 L18.5094522,5.33996507 L16.1955117,7.25423658 C11.803855,10.8924188 8.08607014,15.4554054 5.36390724,20.7066217 C3.72111594,23.8629138 2.45227546,27.2676905 1.57467321,30.8315929 L0.431357649,29.6882774 C0.752732781,26.1892057 1.42408396,22.7201712 2.48242216,19.3620979 C4.38287241,13.3142623 7.50569134,7.62307832 11.6582851,2.71701007 L13.5954885,0.426001338 Z"
      />
    </svg>
  );
}

YellowCardIcon.propTypes = {
  size: PropTypes.number,
};

YellowCardIcon.defaultProps = {
  size: 15,
};
